import type { ViewBinding, ViewId, ViewType } from './contract.js';
import { unmetRequirement } from './assertBinding.js';

/** Le catalogue effectif, identique pour le rendu, l'adresse et la navigation. */
export function typesDePorte(
  porte: { canvas?: unknown; types?: ViewType[]; viewIds?: readonly ViewId[] } | null | undefined,
  catalogue: ViewType[],
): ViewType[] {
  if (porte?.canvas != null) return [];
  const types = porte?.types ?? catalogue;
  if (porte?.viewIds === undefined) return types;
  const parId = new Map(types.map((type) => [type.id, type]));
  return porte.viewIds.flatMap((id) => {
    const type = parId.get(id);
    return type === undefined ? [] : [type];
  });
}

/** Une vue grisee reste proposee, mais ne devient pas la vue d'arrivee. */
export function vueDeCollection<T>(
  types: ViewType[], bindings: ViewBinding<T>[], candidate?: ViewId | null, defaut?: ViewId,
): ViewId | undefined {
  const collections = types.filter((type) => type.level === 'collection');
  const disponibles = collections.filter((type) => unmetRequirement(type, bindings.find((b) => b.type === type.id)) == null);
  return disponibles.find((type) => type.id === candidate)?.id
    ?? disponibles.find((type) => type.id === defaut)?.id
    ?? disponibles[0]?.id
    ?? collections.find((type) => type.id === defaut)?.id
    ?? collections[0]?.id;
}

/**
 * LA VUE DE FICHE OU S'OUVRE UNE FICHE (chantier `fiche-suivi`) : le choix de
 * chacun (« Ouvrir les fiches sur », `pinnedRecordViewPrefKey`) l'emporte, puis
 * le defaut declare de la porte (`auClic.vueDeFiche`, `ScreenDoor.recordView`),
 * puis la premiere vue de fiche du catalogue, `core.fiche` par construction.
 * Une preference ou un defaut qui designe une vue absente du catalogue de la
 * porte est ignore, jamais suivi : la fiche s'ouvrirait sur une impasse.
 *
 * LA SEULE IMPLEMENTATION : le clic sur une ligne, l'adresse a froid et le saut
 * vers une fiche d'une autre porte la lisent toutes les trois ici.
 */
export function vueDeFicheDArrivee(
  types: readonly ViewType[],
  porte: { recordView?: ViewId } | null | undefined,
  preference?: string | null,
): ViewId | undefined {
  const fiches = types.filter((type) => type.level === 'record');
  return fiches.find((type) => type.id === preference)?.id
    ?? fiches.find((type) => type.id === porte?.recordView)?.id
    ?? fiches[0]?.id;
}
